const BASE_URL = process.env.REACT_APP_APPS_SCRIPT_URL;

async function request(body) {
  const res = await fetch(BASE_URL, {
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}

export const getPayrollEmployees = () => request({ action: 'getPayrollEmployees' });
export const savePayrollEmployee = (employee) => request({ action: 'savePayrollEmployee', employee });
export const deletePayrollEmployee = (id) => request({ action: 'deletePayrollEmployee', id });
export const processPayroll = (payload) => request({ action: 'processPayroll', payload });
export const getPayrollRuns = () => request({ action: 'getPayrollRuns' });
